import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import hi from "./locales/hi.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import kn from "./locales/kn.json";
import bn from "./locales/bn.json";
import mr from "./locales/mr.json";
import gu from "./locales/gu.json";
import te from "./locales/te.json";
import ta from "./locales/ta.json";
import or from "./locales/or.json";

// Language mapping for API response
const languageMapping = {
  "en": "en",
  "english": "en",
  "hi": "hi",
  "hindi": "hi",
  "fr": "fr",
  "french": "fr",
  "de": "de",
  "german": "de",
  "kn": "kn",
  "kannada": "kn",
//   "bn": "bn",
//   "bengali": "bn",
//   "mr": "mr",
//   "marathi": "mr",
//   "gu": "gu",
//   "gujarati": "gu",
//   "te": "te",
//   "telugu": "te",
//   "ta": "ta",
//   "tamil": "ta",
//   "or": "or",
//   "odia": "or"
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi },
      fr: { translation: fr },
      de: { translation: de },
      kn: { translation: kn },
    //   bn: { translation: bn },
    //   mr: { translation: mr },
    //   gu: { translation: gu },
    //   te: { translation: te },
    //   ta: { translation: ta },
    //   or: { translation: or }
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"]
    }
  });

// Function to set language based on institute ID
export const setLanguageByInstitute = (instituteId) => {
  // Institute ID 100593 gets French, all others get English
  const language = (instituteId == "105942" || instituteId == "105970") ? "fr" : "en";
  i18n.changeLanguage(language);
  localStorage.setItem("i18nextLng", language);
  return language;
};

// Function to change language based on API response
export const changeLanguageFromAPI = (apiLanguageCode) => {
  if (apiLanguageCode) {
    const normalizedCode = apiLanguageCode.toLowerCase();
    const mappedLanguage = languageMapping[normalizedCode] || "en";
    i18n.changeLanguage(mappedLanguage);
    localStorage.setItem("i18nextLng", mappedLanguage);
  }
};

// Function to get current language
export const getCurrentLanguage = () => {
  return i18n.language || "en";
};

export default i18n;
